import Card from "@/components/Card";
import { formatRupiah } from "@/lib/utils";
import { NominalUkt } from "@/types";
import { Banknote, Building2, GraduationCap } from "lucide-react"; // Pastikan install lucide-react

type DataUKT = Record<string, NominalUkt[]>;

export default function ListUkt({ dataUkt }: { dataUkt: DataUKT }) {
  // Jika data kosong
  if (!dataUkt || Object.keys(dataUkt).length === 0) {
    return (
      <Card className="p-8 text-center border-dashed">
        <p className="text-slate-500">Data UKT tidak tersedia.</p>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-2">
        <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg text-blue-600 dark:text-blue-400">
          <Banknote className="w-6 h-6" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-slate-900 dark:text-white">
            Informasi Biaya Pendidikan
          </h2>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Rincian UKT dan IPI berdasarkan Program Studi pilihan.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6">
        {Object.keys(dataUkt).map((prodiName, index) => {
          const listData = dataUkt[prodiName];

          // Pisahkan IPI dan UKT
          const itemIPI = listData?.find((item) =>
            item.jenis_ukt?.kode_jenis_ukt_sipepeng.startsWith("ipi"),
          );
          const listDataUkt = listData?.filter(
            (item) =>
              item.jenis_ukt?.kode_jenis_ukt_sipepeng?.startsWith("ukt") &&
              item.jenis_ukt?.kode_jenis_ukt_sipepeng !== "ukts1asing",
          );

          return (
            <div
              key={index}
              className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200"
            >
              {/* Header Prodi */}
              <div className="bg-slate-50 dark:bg-slate-800/50 p-4 border-b border-slate-100 dark:border-slate-800 flex items-center gap-3">
                <GraduationCap className="w-5 h-5 text-slate-500" />
                <h3 className="font-bold text-lg text-slate-800 dark:text-slate-100">
                  {prodiName}
                </h3>
              </div>

              <div className="p-5 grid grid-cols-1 gap-8">
                {/* Kolom Kiri: Daftar Kelompok UKT */}
                <div className="space-y-4">
                  <h4 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-2 flex items-center gap-2">
                    <Banknote className="w-4 h-4" /> Kelompok UKT (Per Semester)
                  </h4>

                  <div className="grid sm:grid-cols-2 gap-3">
                    {listDataUkt?.map((ukt) => (
                      <div
                        key={ukt.id_ref_nominal_ukt}
                        className="flex justify-between items-center p-3 rounded-lg border border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50"
                      >
                        <span className="text-sm font-medium text-slate-600 dark:text-slate-400">
                          {ukt.jenis_ukt?.nama_jenis_ukt}
                        </span>
                        <span className="font-bold text-slate-900 dark:text-white">
                          {ukt.nominal_ukt
                            ? formatRupiah(Number(ukt.nominal_ukt))
                            : "-"}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Kolom Kanan: IPI (Highlight) */}
                <div className="lg:border-l lg:pl-8 border-slate-100 dark:border-slate-800 flex flex-col justify-center">
                  <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-xl border border-blue-100 dark:border-blue-800/50 text-center">
                    <h4 className="text-xs font-bold text-blue-600 dark:text-blue-400 uppercase tracking-wider mb-1 flex items-center justify-center gap-1">
                      <Building2 className="w-3 h-3" /> Iuran Pengembangan
                      Institusi
                    </h4>
                    <p className="text-xs text-blue-500/80 mb-3">
                      (Dibayar 1x di awal)
                    </p>

                    <div className="text-lg font-extrabold text-primary">
                      {itemIPI?.nominal_ukt
                        ? formatRupiah(Number(itemIPI.nominal_ukt))
                        : "Rp 0"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
